import BorWorkspace from './BorWorkspace';

export default BorWorkspace;
